import { useSelector } from 'react-redux';
import { lt } from '@mews/framework';
import { SkeletonCard } from '@optimus-web/core';
import { SmartTip } from '@mews/b2b-ui';
import { isCurrentEnterpriseSmartTipsEnabled } from '@mews-commander/legacy-entities/src/selectors/session/subscription';
import { useGuestSmartTips } from '../hooks/useGuestSmartTips';

interface GuestSmartTipsProps {
    guestId: string;
    hasSmartTipsAccess?: boolean;
    useAssistantApi?: boolean;
}

export const GuestSmartTips = (props: GuestSmartTipsProps) => {
    const { guestId, useAssistantApi = true, hasSmartTipsAccess = true } = props;
    const isEnterpriseSmartTipsEnabled: boolean = useSelector(isCurrentEnterpriseSmartTipsEnabled);
    const queryEnabled = isEnterpriseSmartTipsEnabled && hasSmartTipsAccess;

    const { smartTipsResponse, isFetching, error } = useGuestSmartTips(guestId, {
        useAssistantApi,
        queryEnabled,
    });

    if (!queryEnabled) {
        return null;
    }

    if (isFetching) {
        return <SkeletonCard width="100%" height="150px" />;
    }

    if (!smartTipsResponse) {
        return null;
    }

    const { tips } = smartTipsResponse;

    return (
        <SmartTip
            label={tips ? lt('AssistantSmartTipsTitle') : lt('AssistantSmartTipsNotAvailableTitle')}
            disclaimer={tips ? lt('AssistantSmartTipsDisclaimer') : null}
            textMoreButton={lt('MoreInfo')}
            textLessButton={lt('LessInfo')}
        >
            {error ? lt('AssistantSmartTipsErrorMessage') : tips || lt('AssistantSmartTipsNotAvailableBody')}
        </SmartTip>
    );
};
